import React from 'react';
import { DashboardListItem } from './';
import { useAuth } from '@hooks/useAuth';
import { X } from 'react-feather';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const variants = {
  hidden: { left: '-100vw', opacity: 0 },
  visible: { left: 0, opacity: 1 },
};

const SideBar = ({
  dashboardList,
  mainView,
  setSearchParams,
  drawer,
  close,
}) => {
  const action = (item) => {
    setSearchParams({ view: item });
    close();
  };

  const { signout } = useAuth();
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };
  return (
    <motion.aside
      className="dashboard_sidebar_container"
      variants={variants}
      animate={drawer ? 'visible' : 'hidden'}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      initial="hidden"
    >
      <div className="top">
        <div className="logo_section">
          <Link to="/">
            <img src="/logo.svg" alt="logo" className="logo" />
          </Link>
          {window.innerWidth <= 900 && (
            <X size={26} color="white" onClick={close} />
          )}
        </div>
        <ul className="dashboard_list">
          {dashboardList?.map(({ title, icon }) => {
            return (
              <DashboardListItem
                key={title}
                title={title}
                icon={icon}
                action={action}
                mainView={mainView}
                close={close}
              />
            );
          })}
        </ul>
      </div>
      <div className="bottom">
        <button
          className={`dashboard_list_item !bg-transparent`}
          onClick={logout}
        >
          <span className="dashboard_list_item_icon">
            <img
              src={'/dashboard/logout.svg'}
              alt={'Logout'}
              className="dashboard_list_item_icon_src"
            />
          </span>
          <h3 className="dashboard_list_item_title">Logout</h3>
        </button>
      </div>
    </motion.aside>
  );
};

export default SideBar;
